import { useCallback } from 'react';

import { useGenerateGoogleOfflineOAuthUrlLazyQuery, useVerifyGoogleOfflineTokenLazyQuery } from '@/common/graphql';
import { ApiUtils, AUTH_STATE_KEY, getStorageItem, RouterUtils } from '@/common/utils';

export const useGoogleOfflineToken = () => {
  const [verifyGoogleOfflineToken] = useVerifyGoogleOfflineTokenLazyQuery();
  const [generateGoogleOfflineOAuthUrl] = useGenerateGoogleOfflineOAuthUrlLazyQuery({
    onError(error) {
      ApiUtils.handleApiError(error);
    },
  });

  const verifyToken = useCallback(
    async (redirectUri: string) => {
      const offlineToken = await verifyGoogleOfflineToken();

      if (!offlineToken.data?.verifyGoogleOfflineToken) {
        const authState = getStorageItem(AUTH_STATE_KEY);
        const response = await generateGoogleOfflineOAuthUrl({
          variables: {
            state: authState ?? '',
            redirectUri,
          },
        });

        const url = response.data?.generateGoogleOfflineOAuthUrl;
        RouterUtils.externalRedirect(url);
      }

      return offlineToken.data?.verifyGoogleOfflineToken;
    },
    [verifyGoogleOfflineToken, generateGoogleOfflineOAuthUrl],
  );

  return { verifyToken };
};
